import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
interface WhatsAppButtonProps {
  text?: string;
  className?: string;
  variant?: 'primary' | 'outline' | 'large';
  message?: string;
}
export function WhatsAppButton({
  text = 'Hablar por WhatsApp',
  className = '',
  variant = 'primary',
  message = 'Hola Maestro Navy, me gustaría solicitar orientación.'
}: WhatsAppButtonProps) {
  const href = 'https://wa.link/lvbw8v';
  const baseStyles = 'inline-flex items-center justify-center gap-2 font-medium transition-all duration-300 rounded-full';
  const variants = {
    primary: 'bg-whatsapp hover:bg-[#20bd5c] text-white px-6 py-3 shadow-[0_0_20px_rgba(37,211,102,0.3)] hover:shadow-[0_0_30px_rgba(37,211,102,0.5)] transform hover:-translate-y-1',
    outline: 'border border-mystic-gold text-mystic-gold hover:bg-mystic-gold/10 px-6 py-3 hover:shadow-[0_0_20px_rgba(212,175,122,0.2)]',
    large: 'bg-whatsapp hover:bg-[#20bd5c] text-white px-8 py-4 text-lg shadow-[0_0_30px_rgba(37,211,102,0.4)] hover:shadow-[0_0_40px_rgba(37,211,102,0.6)] transform hover:-translate-y-1'
  };
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-232">
      {variant !== 'outline' && <MessageCircle className="w-5 h-5" data-id="element-233" />}
      <span data-id="element-234">{text}</span>
    </a>;
}